import { h } from 'preact'
import classNames from 'classnames'

type Props = {
    success: boolean,
    text: string
}
const Flag = ({ success, text }: Props) =>
  <div class={classNames({ 'flag-success': success })}>
    {text}
  </div>

export default Flag
